import React from "react";
import { CartTable } from "@temp/components";
import { TaxedMoney } from "@temp/@next/components/containers";
import { OrderDetail_lines, OrderDetail_deliveryQuotation } from "@saleor/sdk/lib/fragments/gqlTypes/OrderDetail";
import { ILine } from "../../../components/CartTable/ProductRow";
import { ITaxedMoney } from "@temp/@next/types";

interface CartGroupingProps {
  lines: any;
  total: ITaxedMoney;
  subTotal: ITaxedMoney;
  deliveryQuotation?: OrderDetail_deliveryQuotation | null;
  isForViewing?: boolean;
}

const seedLines = JSON.parse(
  '[{"productName":"Blue Hoodie","quantity":1,"variant":{"id":"UHJvZHVjdFZhcmlhbnQ6MzA1","name":"XXL","sku":"43313080","quantityAvailable":50,"isAvailable":true,"pricing":{"onSale":false,"priceUndiscounted":{"gross":{"amount":30,"currency":"USD","__typename":"Money"},"net":{"amount":30,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"price":{"gross":{"amount":30,"currency":"USD","__typename":"Money"},"net":{"amount":30,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"__typename":"VariantPricingInfo"},"attributes":[{"attribute":{"id":"QXR0cmlidXRlOjEz","name":"Size","__typename":"Attribute"},"values":[{"id":"QXR0cmlidXRlVmFsdWU6NDA=","name":"XXL","value":"XXL","__typename":"AttributeValue"}],"__typename":"SelectedAttribute"}],"product":{"id":"UHJvZHVjdDoxMTY=","name":"Blue Hoodie","thumbnail":{"url":"http://localhost:8000/media/__sized__/products/saleordemoproduct_cl_bogo02_1_8y0sUKR-thumbnail-255x255.png","alt":"","__typename":"Image"},"thumbnail2x":{"url":"http://localhost:8000/media/__sized__/products/saleordemoproduct_cl_bogo02_1_8y0sUKR-thumbnail-510x510.png","__typename":"Image"},"productType":{"isShippingRequired":true,"__typename":"ProductType"},"__typename":"Product"},"__typename":"ProductVariant"},"unitPrice":{"currency":"USD","gross":{"amount":30,"currency":"USD","__typename":"Money"},"net":{"amount":30,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"__typename":"OrderLine"},{"productName":"Yellow Plimsolls","quantity":1,"variant":{"id":"UHJvZHVjdFZhcmlhbnQ6MjQ0","name":"41","sku":"398323585","quantityAvailable":5,"isAvailable":true,"pricing":{"onSale":true,"priceUndiscounted":{"gross":{"amount":59,"currency":"USD","__typename":"Money"},"net":{"amount":59,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"price":{"gross":{"amount":47.2,"currency":"USD","__typename":"Money"},"net":{"amount":47.2,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"__typename":"VariantPricingInfo"},"attributes":[{"attribute":{"id":"QXR0cmlidXRlOjI0","name":"Shoe size","__typename":"Attribute"},"values":[{"id":"QXR0cmlidXRlVmFsdWU6Nzc=","name":"41","value":"41","__typename":"AttributeValue"}],"__typename":"SelectedAttribute"}],"product":{"id":"UHJvZHVjdDo4Nw==","name":"Yellow Plimsolls","thumbnail":{"url":"http://localhost:8000/media/__sized__/products/saleordemoproduct_sneakers_01_1_lkH3rjU-thumbnail-255x255.png","alt":"","__typename":"Image"},"thumbnail2x":{"url":"http://localhost:8000/media/__sized__/products/saleordemoproduct_sneakers_01_1_lkH3rjU-thumbnail-510x510.png","__typename":"Image"},"productType":{"isShippingRequired":true,"__typename":"ProductType"},"__typename":"Product"},"__typename":"ProductVariant"},"unitPrice":{"currency":"USD","gross":{"amount":47.2,"currency":"USD","__typename":"Money"},"net":{"amount":47.2,"currency":"USD","__typename":"Money"},"__typename":"TaxedMoney"},"__typename":"OrderLine"}]'
);

const seedMoney: ITaxedMoney = {
  gross: {
    amount: 0,
    currency: "USD",
  },
  net: {
    amount: 0,
    currency: "USD",
  },
};

const CartGrouping: React.FC<Partial<CartGroupingProps>> = ({
  lines = seedLines,
  total = seedMoney,
  subTotal = seedMoney,
  deliveryQuotation,
  isForViewing,
}) => {
  const shippingPrice:ITaxedMoney = {
    gross: deliveryQuotation?.totalFeeAmount,
    net: deliveryQuotation?.totalFeeAmount
  };
  return (
    <div className="px-2">
      {/* <section className="border-bottom py-3 mb-2">
        <header className="font-weight-bold text-uppercase">
          {merchantName}
        </header>
        <p>Contact Number: {contactName}</p>
        <p>City: {address}</p>
      </section> */}
      <CartTable
        lines={extractOrderLines(lines)}
        totalCost={<TaxedMoney taxedMoney={total} />}
        deliveryCost={<TaxedMoney taxedMoney={shippingPrice} />}
        subtotal={<TaxedMoney taxedMoney={subTotal} />}
        deliveryDistance={deliveryQuotation ? deliveryQuotation?.totalKm : null}
        isForViewing={isForViewing}
      />
    </div>
  );
};

export default CartGrouping;

function extractOrderLines(lines: OrderDetail_lines[]): ILine[] {
  return lines
    .map((line) => ({
      quantity: line.quantity,
      totalPrice: {
        ...line.unitPrice,
        currency: line.unitPrice.currency,
        gross: {
          amount: line.quantity * line.unitPrice.gross.amount,
          ...line.unitPrice.gross,
        },
        net: {
          amount: line.quantity * line.unitPrice.net.amount,
          ...line.unitPrice.net,
        },
      },
      ...line.variant,
      name: line.productName,
    }))
    .sort((a, b) => b.id.toLowerCase().localeCompare(a.id.toLowerCase()));
}
